import React, { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { DashboardLayoutContainer } from 'components/Layouts/DashboardLayout';
import { Button, colors, Grid, Tab, Typography } from '@leapeasy/ui-kit';
import { Box } from '@mui/material';
import styled from 'styled-components';
import { getNotifFromAction, getNotifToAction } from 'store/actions/notifActions';
import { NotificationTo } from './NotificationTo';
import { NotificationFrom } from './NotificationFrom';
import {
  NOTIFICATION_TAB_OUTGOING,
  NOTIFICATION_TAB_RECEIVED,
  NOTIFICATION_TABS,
  parseNotificationTab,
} from './notificationTabs';
import {
  pageHeaderSx,
  pageTitleStyle,
  contentContainerSx,
} from 'containers/User/InviteNewUser/InvitePage/InvitePage.styles';

export const NotificationsPage = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = useMemo(() => parseNotificationTab(searchParams), [searchParams]);

  const handleTabChange = useCallback(
    (index) => {
      const nextTab = NOTIFICATION_TABS[index]?.key ?? NOTIFICATION_TAB_RECEIVED;
      const next = new URLSearchParams(searchParams);
      if (nextTab === NOTIFICATION_TAB_RECEIVED) {
        next.delete('tab');
      } else {
        next.set('tab', nextTab);
      }
      setSearchParams(next, { replace: true });
    },
    [searchParams, setSearchParams],
  );

  const selectedTabIndex = activeTab === NOTIFICATION_TAB_OUTGOING ? 1 : 0;

  const handleRefresh = useCallback(() => {
    if (activeTab === NOTIFICATION_TAB_OUTGOING) {
      dispatch(getNotifToAction());
    } else {
      dispatch(getNotifFromAction());
    }
  }, [activeTab, dispatch]);

  return (
    <DashboardLayoutContainer>
      <PageHeader sx={pageHeaderSx}>
        <Typography variant="h3" style={{ color: colors.purple[900], ...pageTitleStyle }}>
          Notifications
        </Typography>
        <RefreshButtonWrap>
          <Button variant="secondary" size="small" onClick={handleRefresh}>
            Refresh
          </Button>
        </RefreshButtonWrap>
      </PageHeader>
      <Box padding="24px 12px" borderRadius="12px" mt={1} sx={contentContainerSx}>
        <Grid>
          {NOTIFICATION_TABS.map((tab, index) => (
            <Tab
              key={tab.key}
              title={tab.label}
              isSelected={selectedTabIndex === index}
              onClick={() => handleTabChange(index)}
            />
          ))}
        </Grid>
        <TabPanel>
          {activeTab === NOTIFICATION_TAB_RECEIVED ? (
            <NotificationFrom embedded />
          ) : (
            <NotificationTo embedded />
          )}
        </TabPanel>
      </Box>
    </DashboardLayoutContainer>
  );
};

const PageHeader = styled(Box)`
  && {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 15px;
  }
`;

const RefreshButtonWrap = styled.div`
  flex-shrink: 0;
  width: auto;

  button {
    width: auto;
    min-width: auto;
  }
`;

const TabPanel = styled.div`
  margin-top: 20px;
`;
